import { RestaurantBasketSummary } from "./RestaurantBasketSummary";

export default RestaurantBasketSummary;
